<div class="content-wrapper">
    <h3>YOU MAY NOW CLOSE THIS APPLICATION</h3>
    <p><em>SCULPTURE SCREENLOCK V2</em></p>
</div>